import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppService } from '../../app.service';



@Injectable()
export class ApiService {
    private serviceURIAPI = 'api';
    private serviceURIAUTH = 'auth';



    constructor(private service: AppService) { }
    
    do() {
        return this.service.download();
    }

    portfoliodashboard(data): Observable<any[]> {
        return this.service.get(`${this.serviceURIAPI}/portfolio/dashboard`, data);
    }
    

    depositdashboard(data): Observable<any[]> {
        return this.service.get(`${this.serviceURIAPI}/deposit/dashboard`, data);
    }


    disbursementdashboard(data): Observable<any[]> {
        return this.service.get(`${this.serviceURIAPI}/disbursement/dashboard`, data);
    }
    

    

    branches(): Observable<any[]> {
        return this.service.get(`${this.serviceURIAPI}/branches`);
    }


    roles(): Observable<any[]> {
        return this.service.get(`${this.serviceURIAPI}/roles`);
    }

    countries(): Observable<any[]> {
        return this.service.get(`${this.serviceURIAPI}/countries`);
    }

    users(): Observable<any[]> {
        return this.service.get(`${this.serviceURIAPI}/users`);
    }

    resetpassword(data): Observable<any[]> {
        return this.service.post(`${this.serviceURIAUTH}/password/`, data);
    }

    createUser(data): Observable<any[]> {
        return this.service.post(`${this.serviceURIAPI}/users/`, data);
    }

    updateUser(id, data): Observable<any[]> {
        return this.service.patch(`${this.serviceURIAPI}/users/` + id + `/`, data);
    }

    deleteUser(id): Observable<any[]> {
        return this.service.delete(`${this.serviceURIAPI}/users/`, id);
    }

    me(): Observable<any[]> {
        return this.service.get(`${this.serviceURIAUTH}/me/`);
    }


}





// WEBPACK FOOTER //
// D:/FMFB/FMFB Dashboard/src/app/main/pages/api-service.service.ts